import JerryCanIcon from '~/images/icons/jerry_can_icon.png';
import cx from 'classnames';
import {
  amountWithAbbreviation,
  amountWithPrecisionAsRequiredAndComma,
} from '~/javascripts/utils/numberFormatter';
import { observer } from 'mobx-react';

const countryFlags = import.meta.glob('/images/projects/*.png', {
  eager: true,
});

const Header = observer(
  ({ lastUpdatedDate, showSingleCountryImpact, impactStats }) => {
    const imageSrc = showSingleCountryImpact
      ? countryFlags[`/images/projects/${impactStats.code.toLowerCase()}.png`]
          .default
      : JerryCanIcon;

    const headerText = showSingleCountryImpact
      ? impactStats.name
      : 'charity: water';

    const statBoxClasses =
      'flex flex-col items-center justify-center xl-w-auto text-center border-grey-70 border-b-0 xl-p-8';
    const statBoxWidth = showSingleCountryImpact ? 'w-1/2' : 'w-1/3';

    return (
      <div className='theme-design-system-v1 map-header-container flex flex-col xl-flex-row justify-between'>
        <div className='flex flex-col xl-flex-row items-center justify-center p-8 text-center xl-text-left'>
          <img
            className={cx({ 'country-flag': showSingleCountryImpact })}
            src={imageSrc}
          />
          <div className='flex flex-col pl-0 xl-pl-4'>
            <h1 className='heading-xl xl-heading-l text-cw-white pt-4 pb-2 xl-p-0 text-center'>
              {headerText}
            </h1>
            {!showSingleCountryImpact && (
              <p className='body-xs text-cw-white'>
                Last updated: ${lastUpdatedDate}
              </p>
            )}
          </div>
        </div>
        <div
          className={cx(
            'stat-section flex flex-row border border-l-0 border-r-0 xl-border-t-0 py-0 justify-between xl-justify-center',
            { 'min-w-auto': showSingleCountryImpact }
          )}
        >
          <div
            className={cx(
              statBoxClasses,
              statBoxWidth,
              'p-0 xl-border border-grey-70 xl-border-t-0 xl-border-b-0 xl-border-r-0'
            )}
          >
            <h1 className='heading-l text-cw-white'>
              <span className='show-for-mobile-only uppercase'>
                {amountWithAbbreviation(impactStats.people_served_number)}
              </span>
              <span className='show-for-medium-up'>
                {amountWithPrecisionAsRequiredAndComma(
                  impactStats.people_served_number
                )}
              </span>
            </h1>
            <p className='body-2xs text-cw-white show-for-mobile-only'>
              people served
            </p>
            <p className='body-xs text-cw-white show-for-medium-up'>
              people served
            </p>
          </div>
          <div
            className={cx(
              statBoxClasses,
              statBoxWidth,
              'py-7 border border-t-0 border-r-0'
            )}
          >
            <h1 className='heading-l text-cw-white'>
              <span className='show-for-mobile-only uppercase'>
                {amountWithAbbreviation(impactStats.funded_water_projects)}
              </span>
              <span className='show-for-medium-up'>
                {amountWithPrecisionAsRequiredAndComma(
                  impactStats.funded_water_projects
                )}
              </span>
            </h1>
            <p className='body-2xs text-cw-white show-for-mobile-only'>
              water projects
            </p>
            <p className='body-xs text-cw-white show-for-medium-up'>
              water projects
            </p>
          </div>
          {!showSingleCountryImpact && (
            <div
              className={cx(
                statBoxClasses,
                'w-1/3 p-0 border border-t-0 border-r-0'
              )}
            >
              <h1 className='heading-l text-cw-white'>
                {amountWithPrecisionAsRequiredAndComma(
                  impactStats.countries_worked_in
                )}
              </h1>
              <p className='body-2xs text-cw-white show-for-mobile-only'>
                countries
              </p>
              <p className='body-xs text-cw-white show-for-medium-up'>
                countries
              </p>
            </div>
          )}
        </div>
      </div>
    );
  }
);
export default Header;
